/** How recently someone was around, for a chat's header: "Active 7m ago". */
export function formatLastSeen(lastSeen, t) {
  if (!lastSeen) return t("messages.offline") || "Offline";
  const date = new Date(lastSeen);
  const diff = Date.now() - date.getTime();
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  if (minutes < 5) return t("messages.online") || "Online";
  if (minutes < 60) return t("messages.activeMinutesAgo", { minutes }) || `Active ${minutes}m ago`;
  if (hours < 24) return t("messages.activeHoursAgo", { hours }) || `Active ${hours}h ago`;
  if (days < 7) return t("messages.activeDaysAgo", { days }) || `Active ${days}d ago`;
  return t("messages.lastSeen", { date: date.toLocaleDateString() }) || `Last seen ${date.toLocaleDateString()}`;
}
